export default "__VITE_ASSET__CwKPOP$C__"